<template>
  <el-dialog :visible.sync="dialogVisible" width="600px" @close="handleDialogClose" :lockScroll="false">
    <div class="answer_kuang">
      <div class="detail_top">
        <div>知识库详情</div>
      </div>
      <div class="answer_con">
        <div>
          {{detailList.title}}
        </div>
        <div>
          {{detailList.answer}}
        </div>
        <div>
          {{detailList.create_time}}
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        dialogVisible: false,
        consultationForm: {
          contact_phone: '',
          contact_name: '',
          agreeProtocol: false,
          localDetail:this.detailList?this.detailList:{}
        },
        rules: {
          contact_phone: [
            { required: true, message: '请输入联系电话', trigger: 'blur' }
          ]
        }
      };
    },
    props: {
      detailList: {
        type: Object,
        default: {},
      }
    },
    methods: {
      handleDialogClose(){
       this.localDetail={}
      },
      async submitConsultation() {
        if (this.consultationForm.agreeProtocol) {
          this.$refs.consultationForm.validate(async valid => {
            if (valid) {
              let res = await this.$request.post('clusterreserve/add', this.consultationForm)
              if (res.data.code === 0) {
                this.$message.success("提交成功")
              }
              // 发送请求...
              this.dialogVisible = false;
            } else {
              alert('提交失败，联系电话不能为空');
              return false;
            }
          });
        } else {
          alert('请先勾选协议')
        }
      }
    }
  };
</script>

<style lang="css" scoped>
  .l {
    position: relative;
  }

  ::v-deep .el-dialog__wrapper {
    z-index: 2005;
  }

  ::v-deep .el-dialog {
    height: 500px;
  }

  ::v-deep .el-input__inner {
    width: 420px !important;
  }

  ::v-deep .el-dialog__header {
    padding: 0;
  }

  ::v-deep .el-dialog__body {
    padding: 0;
    height: 100%;
  }

  .el-button--primary {
    background: #F58634 !important;
    border-color: #f58634 !important;
  }

  ::v-deep .safety2 {
    color: #1ad2a0;
  }


  ::v-deep .r .text .dl1 dt {
    line-height: 52px;
    font-size: 14px;
  }

  ::v-deep .r .text .dl1 dd {
    line-height: 36px;
    color: #8a8a8a;
  }
</style>